/**
* @author Vytautas Demenius, Indeform Ltd
* @copyright Copyright 2018, Indeform Ltd
* @version 20190528
* @description Profile save modal Component.
*/


import ModalWindow from "./modal-window";

class ProfileSaveModal extends ModalWindow {
    constructor(ui) {
        super(ui, 'profileSaveModal', ['click'], {
            formID: 'profileUpdateForm',
        });
    }
    on_modalSubmit(data, e) {
        // BUG: C:/fakepath/filename.ext when posting with new file (image does not get updated)
        // let form = UI.$ID(this.params.formID);
        // this.ui.ProfileForm.on_submit(form);

        document.getElementById(this.params.formID).submit();
//        this.ui.ProfileForm.on_submit(data, e);
    }
}

export { ProfileSaveModal }
export default ProfileSaveModal



//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/modules/modal-window/profile-save-modal.js
// module id = 342
// module chunks = 0